import DateColumn from '../column-helpers/date/date-component';
import ScheduleTypeColumn from '../column-helpers/schedule_type/schedule-type-component';
import ScheduleStatusColumn from '../column-helpers/schedule_status/schedule-status-component';
import LastOccurrenceStatusColumn from '../column-helpers/last_occurrence_status/last-occurrence-status-component';
import {
  SCHEDULE_LAST_OCCURRENCE_STATUS,
  SCHEDULE_STATUSES,
  SCHEDULE_TYPES,
} from '../column-helpers/scheduleConstants';

const getMappedConstant = (scheduleConstant) => {
  const mappedObject = {};
  Object.values(scheduleConstant).forEach((el) => {
    mappedObject[el.name] = el.title;
  });

  return mappedObject;
};

export const schedulesColumnConfig = {
  solution: {
    label: 'Solution',
    type: 'text',
    width: 220,
    shown: false,
    priority: 1,
  },
  displayName: {
    label: 'Name',
    type: 'text',
    width: 220,
    shown: true,
    priority: 2,
  },
  description: {
    label: 'Description',
    type: 'text',
    width: 300,
    shown: false,
    priority: 3,
  },
  nextExecutionTime: {
    label: 'Next Run',
    dataType: 'date',
    columnRendererComponent: DateColumn,
    width: 140,
    shown: true,
    priority: 4,
  },
  'schedule.type': {
    label: 'Schedule Type',
    type: 'select',
    path: 'schedule.type',
    entityColumn: true,
    columnRendererComponent: ScheduleTypeColumn,
    options: getMappedConstant(SCHEDULE_TYPES),
    width: 140,
    shown: false,
    priority: 5,
  },
  status: {
    label: 'Schedule Status',
    type: 'select',
    columnRendererComponent: ScheduleStatusColumn,
    options: getMappedConstant(SCHEDULE_STATUSES),
    width: 140,
    shown: true,
    priority: 6,
  },
  lastOccurrenceStatus: {
    label: 'Last Run Status',
    type: 'select',
    columnRendererComponent: LastOccurrenceStatusColumn,
    options: getMappedConstant(SCHEDULE_LAST_OCCURRENCE_STATUS),
    width: 140,
    shown: false,
    priority: 7,
  },
  lastExecutionTime: {
    label: 'Last Activity On',
    dataType: 'date',
    columnRendererComponent: DateColumn,
    width: 140,
    shown: false,
    priority: 11,
  },
  createdBy: {
    label: 'Created By',
    dataType: 'string',
    width: 120,
    shown: false,
    priority: 9,
  },
  createdOn: {
    label: 'Created On',
    dataType: 'date',
    columnRendererComponent: DateColumn,
    width: 160,
    shown: false,
    priority: 8,
  },
  updatedBy: {
    label: 'Updated By',
    dataType: 'string',
    width: 120,
    shown: false,
    priority: 12,
  },
  updatedOn: {
    label: 'Updated On',
    dataType: 'date',
    columnRendererComponent: DateColumn,
    width: 160,
    shown: false,
    priority: 10,
  },
};
